import React from 'react'
import ReactDOM from 'react-dom'

import App from 'containers/App'

import 'assets/styles/global.scss'

ReactDOM.render(<App />, document.getElementById('root'))
